import { render, staticRenderFns } from "./ptUser.vue?vue&type=template&id=11150b65&scoped=true&"
import script from "./ptUser.vue?vue&type=script&lang=js&"
export * from "./ptUser.vue?vue&type=script&lang=js&"
import style0 from "./ptUser.vue?vue&type=style&index=0&id=11150b65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11150b65",
  null
  
)

export default component.exports